import React from "react";
import SelectInput from './SelectInput';
import TextInput from './TextInput';
import deleteFattura from './../services/deleteFattura';
import saveFile from "../services/saveFile";
import Cookies from 'universal-cookie';
import uuid from 'react-uuid';
import Constants from "../utils/consts";
import Button from './Button';
import MyDatePicker from "./DatePickerIta";
import moment from 'moment';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import './css/editor.css';
import ImageSilentInput from "./ImageSilentInput";
import translateString from "../utils/Locales";

let tr = translateString;

export default class EditFatturaInsegnanteWidget extends React.Component {

    constructor(props){
        super(props);

        this.rataDateRef = React.createRef();
        this.importoRef = React.createRef();
        this.importo = 0;

        this.options = [];
        this.options.push({ value: 'NON PAGATA', label: tr('NON PAGATA')});
        this.options.push({ value: 'PAGATA', label: tr('PAGATA')});
        this.files = [];
        this.newFiles = [];
        this.deletedFiles = [];
        this.newNote = undefined;

        this.state = {
            option: this.option,
        }
    }

    onContentStateChange = contentState => {

        this.savedEnabled = true;
        this.setState({ contentState});
       }

    refresh(fattura){
        this.fattura = fattura;
        this.data = fattura.data;
        this.importo = fattura.importo;
        this.option = this.options.find(o => o.value == (fattura.flag_pagamento == 1 ? 'PAGATA' : 'NON PAGATA'));
        this.newNote = fattura.note;
        this.files = [];
        fattura.file && fattura.file.split(';').forEach(f => this.files.push(f));

        this.setState({
            option: this.option,
        });
    }

    componentDidMount(){
        this.option = this.options.find(o => o.value == this.props.status);
        this.setState({
            option: this.option,
        });
    }
   
    render (){

        this.files = [];
        var tempArr = this.fattura && this.fattura.file ? this.fattura.file.split(';') : [];
        for (var t of tempArr)
            if (t != '' && this.deletedFiles.indexOf(t) == -1) 
                this.files.push(t);
        for (var t of this.newFiles)
            if (t.src != '' && this.deletedFiles.indexOf(t.src) == -1)
                this.files.push(t.src);

        const rataDataFormatted = moment(this.data, "DD-MM-yyyy").format("yyyy-MM-DD");
        
        return ( 

        <div key={Math.random()}  style={{display: this.props.show == true ? 'block' : 'none'}}> 
            <div style={container} onClick={() => { this.props.onClose(undefined); this.setState({ visible: false }); }}>
            <div style={mainClass} onClick={(e) => e.stopPropagation()}>
                
            <div style={closeBtn} onClick={() => {
                this.setState({visible: false});
                this.props.onClose(null);
            }}>
                <img alt="" src={ require('../images/close_icon.png')} style={{ width: 30, height: 30, cursor: 'pointer' }} />
            </div>

                {this.props.fattura && this.props.fattura.studente && <div>{t('nome')}: {this.props.fattura.studente.nome.replace(/\\/g, '') + ' ' + this.props.fattura.studente.cognome.replace(/\\/g, '')}</div> }
                <div style={{ marginLeft: '5px' }}>{tr('data')} </div>
                <MyDatePicker ref={this.rataDateRef} value={rataDataFormatted} onChange={data => {
                    this.data = data;
                    }
                }/>
                <TextInput key={Math.random()} name={tr('importo')} value={this.importo} 
                    onChange={(text) => { this.importo = text}
                } />

                <SelectInput key={Math.random()} 
                    value={this.state.option} 
                    name={tr('stato') + ":"} 
                    options={this.options} 
                    isMulti={false}
                    onChange={(option) => {
                        this.setState({
                            option: option
                        });
                    }}
                />

                <TextInput key={Math.random()} name={tr('note')} value={this.newNote} 
                    onChange={(text) => { this.newNote = text}
                } />

                <p style={{ marginLeft: 10, marginTop: 30, fontWeight: 'bold' }}>{tr('f_allegati')}</p>
                <div style={{width: '100%', display: 'inline-flex', flexDirection: 'column', overflowY: 'scroll', overflowX: 'hidden', marginBottom: 20 }}>
                {
                    this.files.map((file, ind) => {
                        return <div key={Math.random()} style={{ width: '300px', height: 45, boxShadow: '0px 1px 3px lightgrey',backgroundColor: '#F3F3F3', paddingTop: 5, paddingBottom: 5, paddingLeft: 20, paddingRight: 20, display: 'flex', flexDirection: 'row', justifyContent: 'space-between', borderRadius: 10, cursor: 'pointer', margin: 3  }}>
                            <div style={{ display: 'flex', flexDirection: 'row' }} onClick={() => window.open(file, '_blank')}>
                                    <img src={ require('../images/folder.png') } style={{ height: 30, width: 30, marginTop: 2.5 }} alt="File" />
                                    <p style={{ fontWeight: 'bold', color: 'darkgrey', marginLeft: 20, marginTop: 9, textTransform: 'none' }}>{tr('apri_file')} {ind + 1}</p>
                            </div> 
                            <img src={ require('../images/delete.png') } style={{ height: 20, width: 20, marginTop: 2.5, cursor: 'pointer', marginRight: 10, marginTop: 7 }} title={tr('elimina_immagine')} onClick={(e) => { 
                                        e.stopPropagation();  
                                        if (window.confirm(tr('elimina_immagine')) == false) return;
                                        this.deletedFiles.push(file);
                                        this.setState({ });
                                    }} />
                        </div>;
                    })
                }
                </div>
                <ImageSilentInput name={''} key={Math.random()} 
                    value={this.state.imageToLoad}
                    onChange={async (base64) => {
                    const photoId = uuid()
                    const cookies = new Cookies();
                    const token = cookies.get('token', { path: '/' });
                    const username = cookies.get('username', { path: '/' });

                    let retPhotoObj = await saveFile(username, token, photoId, base64);
                    const fileName = 'https://' + Constants.mainUrl + retPhotoObj.name;
                    this.newFiles.push({
                        id: photoId,
                        src: fileName,
                        width: 1,
                        height: retPhotoObj.height / retPhotoObj.width
                    });

                    this.setState({ });
                    }} 
                />
                
                {
                    this.fattura != undefined && this.fattura.id != undefined && 
                    <Button callback={async () => {

                        if (window.confirm(tr('elimina_fattura')) == false) return;

                        const cookies = new Cookies();
                        const username = cookies.get('username', { path: '/' });
                        const token = cookies.get('token', { path: '/' });

                        await deleteFattura(username, token, this.fattura.id);
                        this.props.onClose(undefined);

                }} title={tr('elimina').toUpperCase()}></Button>
                }
          
                <Button callback={async () => {

                        var filesString = '';
                        for (var str of this.files){
                            if (filesString != '') filesString = filesString + ';';
                            filesString = filesString + str;
                        }

                        var rataDate = this.rataDateRef.current.getDate();
                        rataDate = (moment (rataDate).format("DD-MM-yyyy"));

                        var fattura = this.fattura;
                        if (fattura == undefined) fattura = {};
                        fattura.data = rataDate;
                        fattura.importo = this.importo;
                        fattura.note = this.newNote;
                        fattura.file = filesString;
                        fattura.status = this.state.option.value;

                        if (moment(fattura.data, 'DD-MM-yyyy').isValid() == false){
                            alert (tr('data_n_valida'));
                            return;
                        }
                        if (fattura.importo == ''){
                            alert (tr('importo_n_valido'));
                            return;
                        }

                        this.props.onClose(fattura);

                }} title={tr('salva').toUpperCase()}></Button>
            </div>
            </div>
        </div>
        )
    }


}

const mainClass = {
    position: 'absolute',
    top: '100px',
    left: 'calc((100% - 400px) / 2)', 
    width: '400px',
    minWidth: '350px',
    height: '550px',
    background: 'white',
    padding: '2%', 
    boxShadow: '0px 2px 10px darkgrey',
    borderRadius: '10px', 
    overflowX: 'hidden', 
    overflowY: 'scroll',
}

const container = {
    position: 'fixed', 
    display: 'block', 
    top: 0,
    left: 0, 
    bottom: 0, 
    right: 0,
    minWidth: '100%', 
    minHeight: '100%', 
    backgroundColor: '#3C3C3C4D',
    overflowX: 'hidden', 
    overflowY: 'scroll',
};

const closeBtn = {
    position: 'absolute',
    right: 10,
    top: 10,
    padding: 10,
    cursor: 'pointer', 
    zIndex: 999, 
}